import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=d2fd4496&scoped=true"
import script from "./ProductModal.vue?vue&type=script&lang=js"
export * from "./ProductModal.vue?vue&type=script&lang=js"
import style0 from "./ProductModal.vue?vue&type=style&index=0&id=d2fd4496&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fd4496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2fd4496')) {
      api.createRecord('d2fd4496', component.options)
    } else {
      api.reload('d2fd4496', component.options)
    }
    module.hot.accept("./ProductModal.vue?vue&type=template&id=d2fd4496&scoped=true", function () {
      api.rerender('d2fd4496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ProductModal.vue"
export default component.exports